import {
  Category,
  Discipline,
  FaqPage as HygraphFaqPage,
  Region,
  Specialty,
  TemplateDetail,
} from '@/lib/types';

import { FaqPage } from '@/features/faq-page/type';

export default function faqPageTransformer({
  id,
  title,
  categories,
  discipline,
  specialty,
  state,
  mainContent,
  sidebar,
  templateDetails,
  slug,
  updatedAt,
  publishedAt,
  parent,
}: HygraphFaqPage): FaqPage {
  return {
    parent: parent ? faqPageTransformer(parent) : null,
    __typename: 'FaqPage',
    id,
    title: title || '',
    slug: slug || '',
    categories: categories as Category[],
    specialty: specialty as Specialty,
    discipline: discipline as Discipline,
    state: state as Region,
    modifiedAt: updatedAt,
    publishedAt: publishedAt,
    mainContent: mainContent,
    sidebar: sidebar || null,
    templateDetails: (templateDetails as TemplateDetail) || null,
  };
}
